import { Box } from "@mui/material";
import jccLogo from "../assets/images/jccLogo.png";
import { Outlet, useNavigate } from "react-router-dom";

const AuctionLayout = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box
        sx={{
          height: "8rem",
          paddingX: "3rem",
          paddingY: "1rem",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.07)",
          backgroundColor: "#FFFFFF",
          position: "relative", // Required for zIndex to work
          zIndex: 1100, // Higher than the content below
          display: "flex",
          alignItems: "center"
        }}
      >
        <img
          src={jccLogo}
          height={"100%"}
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/auction/auction-details")}
        />
      </Box>
      <Outlet />
    </Box>
  );
};

export default AuctionLayout;
